import { Component } from '@angular/core';
import { lazyModalsNav } from 'app/app.navigation';
import { iconMacos } from 'core/icons/lib/icon-macos';
import { iconWindows } from 'core/icons/lib/icon-windows';
import { ModalRouter } from 'core/modules/modal';

@Component({
  selector: 'app-promotion-buy-dwrld-card',
  templateUrl: './promotion-buy-dwrld-card.component.html',
  styleUrls: ['./promotion-buy-dwrld-card.component.scss'],
})
export class PromotionBuyDwrldCardComponent {
  readonly macOS = iconMacos;
  readonly windowsOS = iconWindows;

  constructor(private modal: ModalRouter) {}

  goToApplication(): void {
    this.modal.navigate(lazyModalsNav.cashier.buyDcoin());
  }
}
